import { routes } from '../config/api_routes';

export const timeslotService = {

    addTimeSlot: (formData) => {    
        return window.axios.post(routes.addTimeSlotApi,formData)
    },
    
    getTimeSlot: (formData) => {    
        return window.axios.post(routes.getTimeSlotApi,formData)
    },
    
    deleteTimeSlot: (formData) => {    
        return window.axios.post(routes.deleteTimeSlotApi,formData)
    },
    
    getTimeSlotById: (formData) => {    
        return window.axios.post(routes.getTimeSlotByIdApi,formData)
    },
    
    editTimeSlot: (formData) => {    
        return window.axios.post(routes.editTimeSlotApi,formData)
    },

    driversCount: () => window.axios.get(routes.driversCountApi),

    getDataCustomerType: (formData) => {    
        return window.axios.post(routes.getDataCustomerTypeApi,formData)
    },


}